<template>
  <div class="legal-container">
    <div class="menu-links">
      <a class="menu-item" href="/legal/legal">General Terms</a>
      <a class="menu-item active-menu" href="/legal/privacy">Privacy Policy</a>
      <a class="menu-item" target="_blank" href="/static/hellopeter_paia_manual.pdf">PAIA Manual</a>
    </div>
    <h3 class="has-text-weight-bold">Privacy Policy</h3>
    <p>Last Updated on 16 February 2024. By accessing and using this website, the user consents to the processing of their personal information by TKJ Design (Pty) Ltd trading as Hellopeter.com ("Hellopeter") on the basis set out in this
      privacy notice. If the user does not consent, the user must immediately stop accessing and/or using this website.</p>
    <div class="columns legal-columns">
      <!-- LEFT PANEL -->
      <div class="column is-one-third-tablet">
        <nav class="grid__1-4th--md legal-menu">
          <div class="bg-grey p-3">
            <ol class="list--silent text-muted">
              <li><a href="#section1">Introduction</a></li>
              <li><a href="#section2">Definitions and Interpretations</a></li>
              <li><a href="#section3">Responsible Party</a></li>
              <li><a href="#section4">What Personal Information is Collected of Users</a></li>
              <li><a href="#section5">Purpose/s for Collection and Processing of a User's Personal Information</a></li>
              <li><a href="#section27">Purpose/s for Collecting and Processing Third-Party Personal Information</a></li>
              <li><a href="#section6">Collection of Personal Information Directly From a User</a></li>
              <li><a href="#section7">Cookies</a></li>
              <li><a href="#section8">General Conditions for Processing Personal Information</a></li>
              <li><a href="#section9">Disclosure and Sharing of Personal Information</a></li>
              <li><a href="#section10">User's Rights Under Proatia</a></li>
              <li><a href="#section11">Further Processing</a></li>
              <li><a href="#section21">Accuracy, Correctness and Completeness of Personal Information</a></li>
              <li><a href="#section12">Security Safeguards</a></li>
              <li><a href="#section22">Notification of Breach of Security</a></li>
              <li><a href="#section23">Decision based on Personal Information Processed</a></li>
              <li><a href="#section13">Linked Third Party Websites</a></li>
              <li><a href="#section14">Direct Marketing</a></li>
              <li><a href="#section15">Children's Personal Information</a></li>
              <li><a href="#section16">Cross Border Transfers of Personal Information</a></li>
              <li><a href="#section24">Retention of Information</a></li>
              <li><a href="#section25">Returning, Destroying or Deleting Personal Information</a></li>
              <li><a href="#section17">Consent</a></li>
              <li><a href="#section26">Lodging an Objection</a></li>
              <li><a href="#section18">Choice of Law</a></li>
              <li><a href="#section19">Amendment of this Privacy Notice</a></li>
              <li><a href="#section20">Contact</a></li>
            </ol>
          </div>
        </nav>
      </div>
      <div class="column legal-content">
        <ol>

          <li id="section1" class="legal-head">Introduction

            <ol>

              <li>Hellopeter collects, uses and, in some circumstances, shares the personal information of Users in and through this website.
              </li>
              <li>Hellopeter respects the rights of Users whose personal information is collected and used by it, including their right to protection against the unlawful collection, retention, sharing and use of such personal information.
              </li>
              <li>The purpose of this Privacy Notice is to provide Users with information about the information processing activities of Hellopeter.
              </li>
              <li>Hellopeter may amend the provisions of this Privacy Notice to comply with any changes in the law, and/or pursuant to any changes to its information processing activities or privacy practices. Such amendments will be
                published on the website and will become operable from the date of such publication.
              </li>
              <li>This Privacy Notice, and the interpretation and enforcement thereof, will be governed by the laws of the Republic of South Africa.
              </li>
              <li>The provisions of this Privacy Notice must, as far as possible, be incorporated into the agreement between Hellopeter and Users of this website.
              </li>

            </ol>

          </li>

          <li id="section2" class="legal-head">Definitions and Interpretation

            <ol>
              <li>In this Privacy Notice, the following words bear the following meanings (or where not defined herein shall bear the meaning assigned thereto in the POPIA or PROATIA):
                <ol>
                  <li>"business" shall bear the meaning ascribed thereto in the General Terms ;</li>
                  <li>"consent" means any voluntary, specific and informed expression of will in terms of which permission is given by or on behalf of a User for the processing of their personal information;
                  </li>

                  <li>"direct marketing" means to approach a data subject, either in person or by mail or electronic communication, for the direct or indirect purpose of promoting or offering to supply any goods or services to the data
                    subject;
                  </li>
                  <li>"General Terms" means the general terms and conditions contained on the website;</li>
                  <li>
                    "information officer" means Alon Rom;
                  </li>
                  <li>"operator" means an outside third party who processes personal information for or on behalf of Hellopeter in terms of a contract or mandate;
                  </li>

                  <li>"personal information" means any information linked to a User or supplied by a business or information that can identify a User, including but not limited to:
                    <ol>
                      <li>information relating to a User's gender, nationality, ethnic or social origin age, language;
                      </li>
                      <li>information relating to a User's education or their financial, criminal or employment history;
                      </li>
                      <li>a User's identity number, e-mail address, physical address, telephone number, location information or online identifier;
                      </li>
                      <li>a User personal opinions, views or preferences;</li>
                      <li>correspondence sent by a User which is of a private or confidential nature;</li>
                      <li>the views or opinions of others about a User; and</li>
                      <li>the User name if it appears with other personal information relating to that User, or if the disclosure of their name on its own would reveal further personal information about that User;
                      </li>
                    </ol>
                  </li>
                  <li>any Third Party Personal Information;</li>
                  <li>"POPIA" means the Protection of Personal Information Act, including any regulations or codes of conduct promulgated under it;</li>
                  <li>"PROATIA" means the Promotion of Access to Information Act 2 of 2000;</li>
                  <li>"process or processing" means, in relation to personal information, any operation or activity or any set of operations, whether or not by automatic means, including:
                    <ol>
                      <li>the collection, receipt, recording, organisation, collation, storage, updating or modification, retrieval, alteration, consultation or use of that information;
                      </li>
                      <li>dissemination by means of transmission, distribution or making available in any other form; or
                      </li>
                      <li>merging, linking, as well as restriction, degradation, erasure or destruction of that information;
                      </li>
                    </ol>
                  </li>

                  <li>"User" means a visitor or user of this website, or any of the content or services associated with this website;
                  </li>
                  <li>"the website" means the website or any part thereof which is accessible from https://www.hellopeter.com.
                  </li>
                  <li>"Third-Party " means a person who is not a User but whose personal information has been provided to Hellopeter by a business for the purposes set out in clause ‎6 below;</li>
                  <li>"Third Party Personal Information" means the personal information of a Third Party;</li>

                </ol>

                <li>Any reference in this Privacy Notice to:
                  <ol>
                    <li>the singular includes the plural and <em>vice versa</em>;</li>
                    <li>any one gender includes the other genders, as the case may be;</li>
                    <li>an act, regulation or other law is to the version of that law in force at the effective date of this notice and includes any amendment or re-enactment made to that law after the effective date of this notice.
                    </li>
                  </ol>
                </li>
                <li>When calculating any number of days for the purposes of this notice, the first day must be excluded and the last day of the relevant interval included, unless the last day is not a business day, then the last day will be
                  the next succeeding business day.
                </li>
                <li>The word "include" means "include without limitation". Use of the word "include" or "in particular" is for illustration or emphasis only and where followed by specific examples must not be interpreted as limiting the
                  meaning of the general wording preceding it.
                </li>
                <li>A requirement that any notice, request, demand or other communication made in terms of this Privacy Notice must be in writing will be met if it is in the form of a data message as defined in the Electronic Communications
                  and Transactions Act, No. 25 of 2002, and is accessible in a manner usable for subsequent reference.
                </li>
            </ol>

          </li>

          <li id="section3" class="legal-head">RESPONSIBLE PARTY

            <ol>

              <li>Hellopeter will be the party who will be collecting and processing a User or Third Party's personal information and as such is designated as the "responsible party" for the purposes of this Notice.
              </li>

              <li>Hellopeter's contact details are as follows:

                <ol>
                  <li>Physical address: 80 Strand Street, Cape Town 8001, Western Cape, South Africa</li>
                  <li>Telephone number: (021) 206 -5444</li>
                  <li>Email address: legal@hellopeter.com</li>
                  <li>Website address: https://www.hellopeter.com</li>
                </ol>
              </li>

              <li>Hellopeter may instruct third party operators from time to time to undertake certain processing activities relating to the User's personal information or Third Party Personal Information.</li>

            </ol>

          </li>

          <li id="section4" class="legal-head">WHAT PERSONAL INFORMATION IS COLLECTED OF USERS
            <ol>

              <li>Hellopeter may collect the following personal information from the User, or in respect of a Third Party:
                <ol>
                  <li>Initials, first name, surname;</li>
                  <li>Identity number and/or date of birth;</li>
                  <li>Physical and postal address;</li>
                  <li>Email address;</li>
                  <li>Telephone and cellphone numbers;</li>
                  <li>Gender, nationality, ethnic and social origin, age, language preference (as applicable);</li>
                  <li>a User's personal opinions, views or preferences;</li>
                  <li>correspondence sent by a User which is of a private or confidential nature;</li>
                  <li>the views or opinions of others about a User;</li>
                  <li>a User's employment and work history including any letters of reference; and</li>
                  <li>a User's credit information and history.</li>
                </ol>
              </li>
              <li>The supply of personal information by the User to Hellopeter is voluntary and not mandatory. However, if the User refuses to supply any personal information, certain consequences may naturally flow from such a refusal,
                such as preventing Hellopeter from concluding or performing any contract with the User, or preventing Hellopeter from complying with one or more of its obligations in law.
              </li>
              <li>There is no applicable law which directly requires or authorises Hellopeter to collect a User's personal information.
              </li>
              <li>Each business that discloses any Third Party Personal Information to Hellopeter warrants that it has the consent of the Third Party to do so .</li>

            </ol>
          </li>

          <li id="section5" class="legal-head">PURPOSE/S FOR COLLECTION AND PROCESSING OF A USER'S PERSONAL INFORMATION

            <ol>

              <li>Hellopeter may collect a User's personal information and use same for any lawful purpose relating to a function or activity of Hellopeter's business or in any other lawful manner recorded elsewhere in this Privacy Notice.
              </li>

              <li>Such purposes may include the following:
                <ol>
                  <li>to enter into a contract with a User;</li>
                  <li>to perform any obligations under a contract with a User;</li>
                  <li>to comply with a legal obligation;</li>
                  <li>to protect a legitimate interest of a User (unless the User has specifically objected in writing to all or some of the processing activities on reasonable grounds);
                  </li>
                  <li>to pursue its own legitimate interests or the legitimate interests of a third party who it is sharing the information with (unless the User has specifically objected in writing to all or some of the processing
                    activities on reasonable grounds);
                  </li>
                  <li>to process personal information for credit reporting purposes;</li>
                  <li>to process personal information for direct marketing purposes (unless the User has opted out of receiving any direct marketing material);
                  </li>
                  <li>to present content to the User in the most effective way for them and their viewing device and browser;
                  </li>
                  <li>to customise and display content including, but not limited to products, articles, listings and advertisement to the User in a way that Hellopeter feels may interest the User or be most beneficial to them;
                  </li>
                  <li>to send content including, but not limited to products, articles, listings and advertisement content to the User via email or other electronic media, where the User has consented to be contacted by Hellopeter with such
                    content;
                  </li>
                  <li>to enable the User to voluntarily participate in interactive features on the website;</li>
                  <li>to notify the User about changes to the website;</li>
                  <li>to contact the User regarding their orders and/or deliveries.</li>
                  <li>to securely transfer the names, contact information and reviews of Users to the affected businesses for the purposes of allowing businesses to contact the User in respect of reviews published by that User in respect of that business.
                    <ol>
                      <li>The User further consents to any business to whom Hellopeter transfers any personal information as contemplated in clause 5.2.14 above, processing that User's personal information, for analytical purposes connected to their business, provided that such business has bound itself to this Privacy Policy.</li>
                      <li>Each business who receives any personal information as contemplated in clause 5.2.14 above undertakes to Hellopeter that it will only process such personal information for the purposes set out in this Privacy Policy.</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>If Hellopeter intends to process a User's personal information for any other purpose not listed in clause 5.2 or elsewhere in this Privacy Notice, or which is otherwise not automatically permitted by law, it shall ensure
                that it obtains the User's written consent to do so.
              </li>
              <li>Hellopeter shall only sell a User's personal information to a third party with the prior written consent of the User and only to the extent permitted by law.
              </li>
              <li>This clause ‎5, does not apply to Third Party Personal Information.</li>

            </ol>

          </li>

          <li id="section27" class="legal-head">PURPOSE/S FOR COLLECTING AND PROCESSING THIRD-PARTY PERSONAL INFORMATION
            <ol>
              <li>Hellopeter may use a business's Third Party Personal Information, solely for the purposes of:</li>
              <li>contacting the relevant Third Party to invite them to utilize this website to review and comment on their experience with the business;</li>
              <li>entering into a contract with the Third-Party to become a User;</li>
              <li>complying with any legal obligation; and</li>
              <li>any other purpose agreed with the business who provided the Third Party Personal Information;
                <ol>
                  <li>Hellopeter shall not process Third Party Personal Information for any other purpose not listed in clause 6.1, or which is otherwise not automatically permitted by law.</li>
                  <li>If a Third Party becomes a User, this clause 6 shall no longer apply and the provisions of this Privacy Notice, as they apply to Users generally, shall apply.</li>
                  <li>Unless a Third Party becomes a User, Hellopeter shall return the Third Party Personal Information to the business on request and delete same from its records.</li>
                  <li>Hellopeter shall not sell Third Party Personal Information.</li>
                </ol>
              </li>
              <li>Hellopeter shall not process Third Party Personal Information for any other purpose not listed in clause ‎6.1, or which is otherwise not automatically permitted by law.</li>
              <li>If a Third Party becomes a User, this clause ‎6 shall no longer apply and the provisions of this Privacy Notice, as they apply to Users generally, shall apply.</li>
              <li>Unless a Third Party becomes a User, Hellopeter shall return the Third Party Personal Information to the business on request and delete same from its records.</li>
              <li>Hellopeter shall not sell Third Party Personal Information.</li>
            </ol>
          </li>

          <li id="section6" class="legal-head">COLLECTION OF PERSONAL INFORMATION DIRECTLY FROM A USER

            <ol>

              <li>Hellopeter shall, as far as possible, always collect personal information about a User directly from the User, except in the following circumstances:
                <ol>
                  <li>Where personal information is collected from a public record, or from another source if the information has already been made public by the User;
                  </li>
                  <li>where the User has given their written consent to Hellopeter to collect their information from another source;
                  </li>
                  <li>where the collection of a User's personal information from another source will not prejudice any of the User's legitimate interests;
                  </li>
                  <li>where the collection of personal information from another source is necessary to maintain Hellopeter's legitimate interests or those of any third party it intends sharing the information with;
                  </li>
                  <li>where the collection of personal information directly from the User would prejudice the purpose for the collection;
                  </li>
                  <li>where the collection of personal information directly from the User is not reasonably practicable in the circumstances.
                  </li>
                </ol>
              </li>
              <li>If Hellopeter collects personal information from a source other than the User, it shall record in writing the details of that source, including the full names and contact details of that source where applicable.
              </li>
              <li>The User hereby consents to Hellopeter requesting and obtaining credit information pertaining to the User from any reputable credit reporting agency or institution for the purpose of concluding any transaction for the sale
                of goods or services to the User on this website.
              </li>
              <li>Personal information may be collected from or supplied by the User in any of the following ways:
                <ol>
                  <li>during the process of registering as a member on this website;</li>
                  <li>provided by the User as part of their profile pages on the website;</li>
                  <li>when subscribing to a service or participating in a survey offered on this website;</li>
                  <li>when posting a comment, review, reply or recommendation on this website;</li>
                  <li>when requesting further services or information from Hellopeter;</li>
                  <li>when contacting Hellopeter to report a problem with the website or for any other reason;
                  </li>
                  <li>when uploading their curriculum vitae to the website or applying for any job offered; and
                  </li>
                  <li>when completing any forms on the website.</li>
                </ol>
              </li>

              <li>The User may visit the website without providing any personal information. However, the website's servers may still collect technical information regarding the use of the website, which is aggregated for analytical
                purposes, technical maintenance and for improving the content offered on the website. Such information may include details of the User's visit, information about the User's computer, including IP (Internet Protocol) address,
                operating system and browser type, the User's location, and usage information. An individual User will not be identified from or by this information and Hellopeter is entitled to copy, distribute or otherwise use such
                information without limitation.
              </li>

            </ol>

          </li>

          <li id="section7" class="legal-head">COOKIES

            <ol>

              <li>“Cookies” are small text files transferred by a webserver to a User's hard drive and thereafter stored on their computer. The types of information a Cookie collects includes a User's username, the date and time of their
                visits to the website, their browsing history and preferences.
              </li>
              <li>Hellopeter may use Cookies on this website to:
                <ol>
                  <li>distinguish one User from another on the website;</li>
                  <li>remember the User's last session when they return to the website;</li>
                  <li>estimate the website's audience size and usage patterns;</li>
                  <li>store information about the User's preferences, which allows Hellopeter to customize the website and content according to the Users individual preferences; and
                  </li>
                  <li>speed up searches on the website.</li>
                </ol>
              </li>

              <li>The provisions of this clause 8 are only applicable to Cookies used by Hellopeter. In some instances, third-party service providers may use Cookies on the website. Hellopeter cannot and does not control or access Cookies
                used by third party service providers and takes no responsibility therefor.
              </li>
              <li>The User has the right and ability to either accept or decline the use of Cookies on their computer's web browser, whether they are logged in as a member, or simply casually visiting the website. However, declining the use
                of Cookies may limit a User's access to certain features on the website.
              </li>

            </ol>

          </li>

          <li id="section8" class="legal-head">GENERAL CONDITIONS FOR PROCESSING PERSONAL INFORMATION

            <ol>

              <li>Hellopeter shall comply with all applicable laws, contracts or regulations when it processes a User's personal information or Third Party Personal Information.
              </li>
              <li>Hellopeter shall not act unreasonably when processing a User's personal information. This means that it will collect and process a User's personal information in a way that the User can reasonably expect and in a way that
                is fair.
              </li>
              <li>Hellopeter shall respect the User's right to privacy at all times. If there is another way in which it can achieve the same goal without posing any risk of harm to the privacy rights of the User, then it will choose that
                option.
              </li>
              <li>Similarly, if Hellopeter needs to process personal information but there are less privacy-invasive methods of collecting, using and sharing that information, then it will use those methods.
              </li>
              <li>Hellopeter shall ensure that the personal information that is collected and processed is and remains relevant to the identified purpose/s for such processing, and that such information is and remains adequate, but not
                excessive, for achieving the identified purpose/s.
              </li>
              <li>If there are any alternative ways to achieve the identified purpose/s without processing personal information, Hellopeter shall not process that personal information.
              </li>
              <li>Hellopeter shall ensure that the processing activities it chooses to apply are proportionate to achieving the identified purpose/s and that no less privacy invasive measures are available to achieve the same purpose/s.
              </li>
              <li>Hellopeter shall ensure that, regardless of the stated purpose/s for processing personal information, the rights and interests of Users will not be unnecessarily prejudiced or infringed, unless it cannot be avoided, and
                then in such cases, it shall ensure that its own rights and/or interests justify such prejudice or infringement taking place.
              </li>
              <li>Once Hellopeter has achieved the purpose for the collection of the User’s personal information, it will destroy or delete such information, unless the User has directed otherwise in writing, or Hellopeter is required by
                law to retain the information for a longer period of time.
              </li>
              <li>If Hellopeter no longer needs to process personal information to achieve the purpose originally specified, it will stop using that information.
              </li>
            </ol>

          </li>

          <li id="section9" class="legal-head">DISCLOSURE AND SHARING OF PERSONAL INFORMATION

            <ol>
              <li>Hellopeter may, in the course of providing any content or services on this website, or for the purposes of concluding or performing any sale or other transaction with a User, share certain personal information of Users or
                Third Parties with third party operators who perform certain processing activities on behalf of Hellopeter.
              </li>
              <li>Third party operators with whom it is shared include but are not limited to:
                <ol>
                  <li>Delivery and courier service providers (User's address, contact name and telephone number may be supplied);
                  </li>
                  <li>Payment Gateway Provider (User's full names, credit card details);</li>
                  <li>Bulk email delivery providers (User's email addresses);</li>
                  <li>Potential providers of goods and services to you if you utilise certain of the functionality on the website including the “Help Request Function”
                  </li>
                </ol>
              </li>

              <li>Hellopeter may also share aggregated information about Users of this website and their usage patterns. Hellopeter may also use such aggregated information to help advertisers target specific audiences. Such aggregated
                information will be de-identified and the User's personal information will not be disclosed.
              </li>
              <li>Other than as stated in clause 10.1 and 10.2 and 10.3, Hellopeter shall not share a User's personal information or Third Party Personal Information with any third parties save as otherwise set out in this Privacy Notice or unless
                it has the User's express consent to do so.
              </li>

            </ol>

          </li>

          <li id="section10" class="legal-head">USER'S RIGHTS UNDER PROATIA

            <ol>
              <li>Users shall have the following rights in relation to the processing of their personal information:
                <ol>
                  <li>to access and correct any personal information held by Hellopeter about them;
                  </li>
                  <li>to object to the processing of their information; and
                  </li>
                  <li>to lodge a complaint with the Information Regulator.
                  </li>
                </ol>
              </li>
              <li>
                Users may exercise any of their rights in terms of 11.1.1 by following the process for making such a request as set out in Hellopeter's PROATIA manual.
              </li>
            </ol>

          </li>

          <li id="section11" class="legal-head">FURTHER PROCESSING

            <ol>

              <li>Hellopeter may also use a User's personal information in the following circumstances:
                <ol>
                  <li>where the User has consented to such further processing;
                  </li>
                  <li>where the further processing is necessary for the exercise of any contractual rights or the fulfillment of any obligations between Hellopeter and the User;
                  </li>
                  <li>where the further processing activities are linked to or compatible with the original purpose;
                  </li>
                  <li>where the further processing is necessary for the prevention, detection, investigation, prosecution and punishment of an offence;
                  </li>
                  <li>where the further processing is necessary to enforce or comply with any law;</li>
                  <li>where the further processing is necessary for the conduct of legal proceedings in any court or tribunal that have commenced or are reasonably contemplated;
                  </li>
                  <li>where the further processing is necessary to prevent or mitigate a serious and imminent threat to the life or health of the User or another individual;
                  </li>
                  <li>where the further processing is used for historical, statistical or research purposes.
                  </li>
                </ol>
              </li>
              <li>Hellopeter shall ensure that if it intends processing personal information for other purposes not previously specified, it shall notify the User of such further purposes and the possible consequences of the intended
                further processing for the User.
              </li>
            </ol>

          </li>

          <li id="section21" class="legal-head">ACCURACY, CORRECTNESS AND COMPLETENESS OF PERSONAL INFORMATION
            <ol>
              <li>Hellopeter shall take reasonably practicable steps to ensure that the personal information kept by it about Users is complete, accurate, not misleading and is updated when necessary.
              </li>
              <li>However, if a User is aware of any personal information in Hellopeter’s custody that is incorrect, inaccurate or which needs to be updated, the User must make a written request to Hellopeter’s information officer at
                admin@hellopeter.com to update or correct the relevant information.
              </li>
              <li>If a User has contested the accuracy of any personal information being used by Hellopeter, it shall immediately stop using that information until its accuracy has been verified.
              </li>
              <li>Hellopeter reserves its right to only adhere to a request from a User in terms of clause 13.2 if the correction or updating of that information will result in the personal information being correct and accurate.
              </li>
              <li>Where personal information that has been shared by Hellopeter with a third party is subsequently updated or corrected, Hellopeter shall ensure that all third parties, with whom that information was shared, receives the
                updated and/or corrected version of the information as soon as it has been updated and/or corrected.
              </li>
            </ol>
          </li>

          <li id="section12" class="legal-head">SECURITY SAFEGUARDS

            <ol>

              <li>Hellopeter is committed to protecting the personal information in its custody against any loss of, damage to or unauthorised destruction of that information, and to prevent any unauthorised parties from accessing that
                information. Hellopeter shall take reasonable steps in this regard but to the maximum extent permitted by law shall not be liable for any loss arising as a result of a failure of its systems.
              </li>
              <li>Hellopeter takes steps to continually identify and document any risks to the personal information it has in its possession or under its control and that appropriate security safeguards are in place against those risks.
              </li>
              <li>Hellopeter shall ensure that in any contracts entered into with third party operators who process personal information on Hellopeter’s behalf, include the following obligations:
                <ol>
                  <li>the operator shall not process any personal information without Hellopeter’s knowledge and authority;
                  </li>
                  <li>the operator shall treat all personal information given to it as confidential and shall not disclose it to any unauthorised third parties;
                  </li>
                  <li>the operator shall establish and maintain adequate security measures which are the same or offer similar protection over the personal information as that employed by Hellopeter;
                  </li>
                  <li>the operator shall notify Hellopeter immediately where there are reasonable grounds to believe that any personal information has been leaked to or accessed by any unauthorised person;
                  </li>
                  <li>if the operator is situated in another country, it must comply with the data protection laws in that country and be able to provide verification that it is so compliant;
                  </li>
                  <li>if an operator is legally obliged to disclose any personal information processed by them on Hellopeter’s behalf to other parties, it must notify Hellopeter beforehand to enable Hellopeter and/or individual Users to
                    protect their rights if necessary.
                  </li>
                </ol>
              </li>
              <li>Users must maintain the secrecy of any passwords used to gain access to this website and should change such passwords regularly.
              </li>
              <li>Hellopeter shall ensure that all personal information on its systems is properly backed-up and that back-up copies are stored separately from the live files.
              </li>
            </ol>

          </li>
          <li id="section22" class="legal-head">NOTIFICATION OF BREACH OF SECURITY
            <ol>
              <li>If personal information is inadvertently leaked or Hellopeter’s security has been unlawfully breached by any unauthorised party, Hellopeter shall as soon as possible identify the relevant persons who may be affected by the
                security breach, and shall contact relevant User (or business in the case of Third Party Personal Information) at their last known email address or contact details or by the quickest means possible.
              </li>
              <li>Hellopeter shall provide sufficient information to the User to allow them to take the necessary protective measures against the potential consequences of the compromise, or shall advise Users of the steps to be taken by
                them and the possible consequences that may ensue from the breach for them.
              </li>
            </ol>
          </li>
          <li id="section23" class="legal-head">DECISIONS BASED ON PERSONAL INFORMATION PROCESSED
            <ol>
              <li>If Hellopeter is required to make a decision about a User using any personal information that has been obtained, it shall ensure that a record of such information and the decision made is kept for a reasonable period of
                time to give the User an opportunity to request access to that record.
              </li>
              <li>Hellopeter shall allow a User a reasonable opportunity to make representations before any decision is made solely on the basis of the personal information processed, if that decision will affect the legal position of the
                User, or will otherwise adversely affect them in some manner or form.
              </li>
              <li>Hellopeter shall always ensure that the underlying logic behind any decision made pursuant to the automated processing of personal information is sound and that this underlying logic can be communicated to the User to
                enable them to make representations.
              </li>
              <li>If Hellopeter has made a decisions based on incorrect personal information, it shall as soon as possible revisit that decision as soon as it receive notice or becomes aware of the error or inaccuracy of that information.
              </li>
            </ol>
          </li>
          <li id="section13" class="legal-head">LINKED THIRD PARTY WEBSITES

            <ol>

              <li>This website may contain links or references to other websites, including those of advertisers (“
                <strong>third party websites</strong>“) which are not under Hellopeter's control.
              </li>
              <li>The provisions of this Privacy Notice are not applicable to third party websites and Hellopeter shall not responsible for the information processing practices and/or privacy policies of those third party websites, or the
                cookies that those websites may use.
              </li>

            </ol>

          </li>

          <li id="section14" class="legal-head">DIRECT MARKETING

            <ol>

              <li>The User hereby consents to the processing of their personal information for the purpose of direct marketing by means of electronic communications including automatic calling machines, facsimile machines, SMS's or
                electronic mail.
              </li>

              <li>Where a User is a pre-existing customer of Hellopeter, Hellopeter shall be entitled, without the User's consent, to sending electronic communications to the User for the purpose of marketing similar products or services
                offered by Hellopeter.
              </li>
              <li>The User may object, free of charge, and without unnecessary formality, to the use of their details either when the information was first collected from them or when each subsequent electronic communication is sent to them
                by Hellopeter.
              </li>
              <li>The User can opt out of receiving further marketing communications by un-checking certain boxes on the forms used on the website to collect their personal information, or by contacting Hellopeter at admin@hellopeter.com.
              </li>

            </ol>

          </li>

          <li id="section15" class="legal-head">CHILDREN'S PERSONAL INFORMATION <br/>

            <span>
       Hellopeter shall not process any personal information relating to a person under the age of 18 years unless it has obtained consent from that person's parent or legal guardian. If this website is being accessed by the parent or guardian of a child under the age of 18 years, and personal information pertaining to that child is being provided by the parent or guardian, then they hereby expressly consent to Hellopeter processing such information according to the further provisions of this Privacy Notice.
       </span>

          </li>

          <li id="section16" class="legal-head">CROSS BORDER TRANSFERS OF PERSONAL INFORMATION

            <ol>
              <li>Subject to clause 20.2, Hellopeter does not intend sharing a User’s personal information with a third party in another country.
              </li>
              <li>Hellopeter may transfer personal information to another country in the following circumstances:
                <ol>
                  <li>the transfer is necessary for the performance of a contract that Hellopeter has with the User;
                  </li>
                  <li>the transfer is necessary for the implementation of pre-contractual measures taken in response to the User's request;
                  </li>
                  <li>the transfer is necessary for the conclusion or performance of a contract with a third party which is for the benefit of or in the interest of the User;
                  </li>
                  <li>the transfer is otherwise for the benefit of the User; or
                  </li>
                  <li>the User has consented to the transfer of their information.
                  </li>
                </ol>
              </li>
              <li>If Hellopeter is required to transfer personal information from South Africa to a third party in a foreign country, it shall ensure that the third party is subject to a law, binding code of conduct or contract which
                effectively upholds principles for the reasonable processing of personal information which are substantially similar to the data protection offered in the Republic of South Africa.
              </li>
              <li>The User further consents to any business to whom Hellopeter transfers any personal information as contemplated in clause 5.2.14 above, transferring such personal information to a third party in a foreign country provided that such business has bound itself to this Privacy Policy.</li>
              <li>Each business who receives any personal information as contemplated in clause 5.2.14 above undertakes to Hellopeter that the third party who processes such personal information is subject to a law, binding code of conduct or contract which effectively upholds principles for the reasonable processing of personal information which are substantially similar to the data protection offered in the Republic of South Africa.</li>
            </ol>

          </li>
          <li id="section24" class="legal-head">RETENTION OF INFORMATION
            <ol>
              <li>Hellopeter will keep a record of any personal information collected for no longer than is necessary to achieve the specific purpose for which it collected such information in the first place unless:
                <ol>
                  <li>It is required by law to keep a record of such information for a longer period of time; or
                  </li>
                  <li>It needs to keep a record of such information for another lawful purpose; or
                  </li>
                  <li>It has a contractual obligation to keep a record of such information; or
                  </li>
                  <li>The User has consented to their information being kept for a longer period.
                  </li>
                </ol>
              </li>
              <li>Hellopeter may, if it has de-identified personal information, keep such information for historical, statistical or research purposes. Hellopeter shall ensure that appropriate safeguards are in place to prevent those
                records from being used for any other purposes, or against the information being re-identified.
              </li>
            </ol>
          </li>
          <li id="section25" class="legal-head">RETURNING, DESTROYING OR DELETING PERSONAL INFORMATION
            <ol>
              <li>Where Hellopeter is no longer authorised to retain a record of any personal information, including if a User closes their account with Hellopeter, Hellopeter shall either:
                <ol>
                  <li>ensure that the information is permanently destroyed or deleted as soon as reasonably practicable; or
                  </li>
                  <li>return the information to the User or transfer it to a third party, if requested by the User in writing to do so.
                  </li>
                </ol>
              </li>
              <li>If the User has a Hellopeter account, the User can access, edit, or delete the personal information associated with that account at any time by logging into his or her account. A User may also email <a
                href="mailto:legal@hellopeter.com">legal@hellopeter.com</a> and request an edit or deletion of his or her personal information at any time. If the User has an account with Hellopeter and the personal information is required
                by Hellopeter for the operation or functionality of his or her account, the User may be required to close his or her account with Hellopeter before Hellopeter can delete it. Notwithstanding any request to delete any personal
                information, Hellopeter may retain personal information after such request where required to do so by applicable law.
              </li>
            </ol>
          </li>
          <li id="section17" class="legal-head">CONSENT
            <ol>

              <li>The User hereby consents to the processing of their personal information in terms of the provisions of this Privacy Notice.
              </li>

              <li>The User acknowledges and agrees that such consent has been given voluntarily after the User has read and understood the provisions of this Privacy Notice, in particular, regarding the following:
                <ol>
                  <li>the types of personal information to be processed;</li>
                  <li>the specific processing activities to be undertaken;</li>
                  <li>the specific purpose/s for such processing; and</li>
                  <li>the possible consequences for the User that may arise from such processing.</li>
                </ol>
              </li>
              <li>
                Should a User wish to withdraw any consent previously given by the User, they must notify Hellopeter’s information officer in writing.
              </li>
            </ol>
          </li>
          <li id="section26" class="legal-head">LODGING AN OBJECTION <br/>
            <ol>
              <li>A User may, on reasonable grounds, object to the processing of their personal information at any time after that processing has started.
              </li>
              <li>If a User wishes to object to the processing of their personal information, they must send written notice of their objection to Hellopeter’s information officer, together with their reasons for doing so.
              </li>
            </ol>
          </li>
          <li id="section18" class="legal-head">CHOICE OF LAW <br/>
            <span>This Privacy Notice shall be governed and interpreted in accordance with the laws of the Republic of South Africa.</span>
          </li>

          <li id="section19" class="legal-head">AMENDMENT OF THIS PRIVACY NOTICE
            <ol>

              <li>Hellopeter reserves the right to change, update, add, remove and/or amend any of the provisions of this Privacy Notice from time to time. Such changes, updates, additions, removals or amendments will become effective from
                the date of their publication on this website.
              </li>
              <li>It is the User's obligation to periodically check the provisions of this Privacy Notice for any such changes, updates, additions, removals or amendments.
              </li>
              <li>The User's continued use of this website following any changes, updates, additions, removals or amendments to this Privacy Notice will be considered notice of the User's acceptance to abide by and be bound by this Privacy
                Notice, as amended.
              </li>

            </ol>
          </li>

          <li id="section20" class="legal-head">CONTACT <br/>
            <span>For more information on your rights to privacy over your information, or the information processing activities of Hellopeter, please do not hesitate to contact us directly on legal@hellopeter.com or alternatively contact (021) 206-5444.</span>
          </li>

        </ol>
        <h4 class="back-to-top has-text-right"><a @click.prevent="backToTop">BACK TO TOP</a></h4>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LegalPrivacy',
  metaInfo () {
    return {
      title: 'Hellopeter.com | Privacy Policy',
      meta: [{name: 'ROBOTS', content: 'NOINDEX, FOLLOW'}]
    }
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Privacy Policy',
      brandName: '',
      industryName: ''
    })
    window.prerenderReady = true
  },
  methods: {
    backToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.legal-columns {
  max-width: 1125px;
  color: #58595B;
  margin: 3rem auto 2rem auto;
}

.legal-columns > .column:first-child {
  background-color: #F5F5F5;
}

.legal-columns > .column {
  padding-top: 0;
}

.legal-columns > .column:nth-child(2) {
  padding-left: 4rem;
  padding-right: 0;
}

.legal-container {
  margin-top: 8rem;
}

.legal-container > h1, .legal-container > h3, .legal-container > p {
  max-width: 1125px;
  color: #58595B;
  margin: 0 auto 1rem auto;
}

.legal-container > h3 {
  font-size: 1.3rem;
}

.legal-container > .menu-links {
  max-width: 1125px;
  color: #58595B;
  margin: 2rem auto 1rem auto !important;
}

.legal-container > .menu-links > a {
  font-size: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;
  color: #58595B;
  border-right: 1px solid #58595B;
}

.legal-container > .menu-links > a:last-child {
  padding-right: 0;
  border: none;
}

.legal-container > .menu-links > a:first-child {
  padding-left: 0;
}

.legal-menu {
  color: #666;
  padding: 3rem 2rem;
}

.legal-menu li {
  margin-bottom: 1.2rem;
  font-size: 0.8rem;
}

.legal-menu li > a, .legal-menu li > a:visited {
  text-decoration: none;
  color: #666;
}

.legal-menu li > a:hover {
  text-decoration: underline;
}

.legal-content a {
  color: map-get($colors, 'blue-v2');
}

.legal-content h1 {
  text-align: left;
  font-size: 20px;
  font-weight: normal;
}

.legal-content p {
  font-size: 14px;
  font-weight: normal;
  text-align: justify;
}

.legal-content li {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 12px;
  text-align: justify;
  display: block;
}

.legal-content ol {
  counter-reset: item;
  padding-left: 30px;
  text-align: justify;
}

.legal-content ol li::before {
  content: counters(item, ".", decimal) ". ";
  counter-increment: item;
}

.legal-content ol > li {
  color: map-get($colors, 'blue-dark');
  font-weight: bold;
  text-align: left;
  font-size: 20px;
  text-transform: uppercase;
}

.legal-content ol > li > ol > li {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 12px;
  text-align: justify;
  display: block;
  font-weight: normal;
  color: #666;
  text-transform: none;
}

.legal-head > span {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 12px;
  text-align: justify;
  display: block;
  font-weight: normal;
  color: #666;
  text-transform: none;
}

.active-menu {
  color: map-get($colors, 'blue-v2') !important;
}

.back-to-top > a, .back-to-top > a:visited, .back-to-top > a:hover {
  margin-top: 4rem;
  color: map-get($colors, 'blue-v2');
  text-decoration: underline;
  font-size: 0.75rem !important;
}

@media screen and (max-width: 1024px) {
  .legal-columns {
    max-width: 95%;
  }

  .legal-columns > .column:nth-child(2) {
    padding-left: 2rem;
    padding-right: 0;
  }
}

@media screen and (max-width: 767px) {
  .legal-columns {
    width: 100%;
    max-width: 100%;
    margin: 4rem 0 2rem 0;
  }

  .legal-columns > .column:first-child {
    padding-top: 2rem;
    padding-bottom: 0;
  }

  .legal-columns > .column:nth-child(2) {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 2rem;
  }

  .legal-container > h1, .legal-container > h3, .legal-container > p, .legal-container > .menu-links {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .legal-container > .menu-links > a {
    font-size: 0.8rem;
    padding-right: 0;
    padding-left: 0;
    border-right: none;
    display: block;
    width: 100%;
    margin-bottom: 0.5rem;
    text-decoration: underline;
  }

  .legal-content > ol {
    padding-left: 0 !important;
  }

  .legal-content li, .legal-content p, .legal-content span {
    font-size: 0.8rem !important;
    padding-left: 0 !important;
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/legal/Privacy.vue